<mat-sidenav-container
  #drawerContainer
  *ngIf="isLoggedIn() && userHasProfile() && userHasBeenOnboarded()"
  class="sidenav-container"
  autosize>
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <mat-toolbar *ngIf="!companyIcon" id="logo-tool-bar" class="tool-bar-shadow">
      <!-- Si tiene logo personalizado: mostrar logo de la empresa -->
      <ng-container *ngIf="companyLogo">
        <img [src]="companyLogo" class="company-logo-toolbar" alt="Company logo" />
      </ng-container>
      
      <!-- Si NO tiene logo personalizado: mostrar logo por defecto de Alimentium -->
      <ng-container *ngIf="!companyLogo">
        <img height="40" src="/img/logo-alimentium-white-small.png" />
      </ng-container>
    </mat-toolbar>

    <div class="app-user">
      <div class="app-user-controls">

        <mat-form-field matTooltip="{{selectedCompany.legalName}}" matTooltipPosition="below" appearance="outline"
          class="alim-mat-form-field company-selector" 
          (click)="isHandset && openChangeCompanyDialog($event)"
          (contextmenu)="!isHandset && openChangeCompanyDialog($event)">
          <mat-select [(value)]="selectedCompany" [disabled]="isCompanySelectorDisabled" panelClass="company-selector-panel">
            <mat-select-trigger>
              <!-- Si tiene icon: mostrar solo el icon completo -->
              <ng-container *ngIf="companyIcon">
                <img [src]="companyIcon" class="company-logo-full" alt="Company logo" />
              </ng-container>
              
              <!-- Si NO tiene icon pero SÍ tiene smallIcon: mostrar smallIcon + nombre -->
              <ng-container *ngIf="!companyIcon && companySmallIcon">
                <img [src]="companySmallIcon" class="company-icon-image" alt="Company icon" />
                <span class="company-name">{{ selectedCompany.name }}</span>
              </ng-container>
              
              <!-- Si NO tiene icon NI smallIcon: mostrar fábrica + nombre -->
              <ng-container *ngIf="!companyIcon && !companySmallIcon">
                <mat-icon class="company-icon">factory</mat-icon>
                <span class="company-name">{{ selectedCompany.name }}</span>
              </ng-container>
            </mat-select-trigger>
            @for (option of companies; track option) {
            <mat-option [value]="option">
              {{ option.name}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div *ngIf="hasCustomStyles" class="powered-by">
          <span class="powered-by-text">Powered by</span>
          <img src="/img/logo-alimentium-white-small.png" class="powered-by-logo" alt="Alimentium" title="Alimentium" />
        </div>

        <div class="icon-buttons-bar">

          <a matTooltip="{{ 'NAVIGATION.SETTINGS' | translate }}" (click)="openUserOptionsMenu()">
            <mat-icon class="mat-icon-button">settings</mat-icon>
          </a>

          <button
            type="button"
            mat-icon-button
            class="theme-toggle-trigger"
            [matTooltip]="(isDarkMode ? 'NAVIGATION.LIGHT_MODE' : 'NAVIGATION.DARK_MODE') | translate"
            [attr.aria-label]="(isDarkMode ? 'NAVIGATION.LIGHT_MODE' : 'NAVIGATION.DARK_MODE') | translate"
            [attr.aria-pressed]="isDarkMode"
            (click)="toggleThemeMode()">
            <mat-icon class="mat-icon-button">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
          </button>

          <button
            mat-icon-button
            matTooltip="{{ 'NAVIGATION.NOTIFICATIONS' | translate }}"
            (click)="openNotificationsDialog()"
            class="notifications-trigger">
            <mat-icon
              [matBadge]="unreadNotificationsCount"
              [matBadgeHidden]="unreadNotificationsCount === 0"
              matBadgeColor="warn"
              class="mat-icon-button">notifications</mat-icon>
          </button>

          <button
            type="button"
            mat-icon-button
            class="logout-trigger"
            [matTooltip]="'NAVIGATION.SIGN_OUT' | translate"
            [attr.aria-label]="'NAVIGATION.SIGN_OUT' | translate"
            (click)="logout()">
            <mat-icon class="mat-icon-button">exit_to_app</mat-icon>
          </button>

        </div>
      </div>
    </div>

    <mat-nav-list>
      <a mat-button routerLink="/home" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>dashboard</mat-icon>
          <span>{{ 'MENU.HOME' | translate }}</span>
        </div>
      </a>
      <mat-divider id="1"></mat-divider>

      <a *ngIf="existInModulesAndCanAccess('PRODUCTS')" mat-button routerLink="/products" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>fastfood</mat-icon>
          <span>{{ 'MENU.PRODUCTS' | translate }}</span>
        </div>
      </a>
      <a *ngIf="existInModulesAndCanAccess('SUPPLIERS')" mat-button class="grouped-item" routerLink="/providers"
        routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>factory</mat-icon>
          <span>{{ 'MENU.PROVIDERS' | translate }}</span>
        </div>
      </a>
      <a *ngIf="existInModulesAndCanAccess('CUSTOMERS')" mat-button class="grouped-item" routerLink="/customers"
        routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>group</mat-icon>
          <span>{{ 'MENU.CLIENTS' | translate }}</span>
        </div>
      </a>
      <a *ngIf="existInModulesAndCanAccess('DISTRIBUTORS')" mat-button class="grouped-item" routerLink="/distributors"
        routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon class="clients-icon">group</mat-icon>
          <span>{{ 'MENU.DISTRIBUTORS' | translate }}</span>
        </div>
      </a>
      <mat-divider *ngIf="hasElementsBetweenDivider1And2()" id="2"></mat-divider>

      <a *ngIf="existInModulesAndCanAccess('CHANNELS')" mat-button routerLink="/channels" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>hub</mat-icon>
          <span>{{ 'MENU.CHANNELS' | translate }}</span>
        </div>
      </a>

      <a mat-button routerLink="/ai-agents" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>psychology</mat-icon>
          <span>{{ 'MENU.AI_AGENTS' | translate }}</span>
        </div>
      </a>
      <mat-divider *ngIf="hasElementsBetweenDivider2And3()" id="3"></mat-divider>

      <a *ngIf="existInModulesAndCanAccess('DIGITALIZATIONS')" mat-button routerLink="/digitalitzations"
        routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>document_scanner</mat-icon>
          <span>{{ 'MENU.DIGITALITZATIONS' | translate }}</span>
        </div>
      </a>
      <!-- <a *ngIf="existInModulesAndCanAccess('ALIGMENTS')" mat-button routerLink="/alignments" routerLinkActive="active">
        <div class="alimentium-item-menu">
          <mat-icon>description</mat-icon>
          <span>{{ 'MENU.ALIGNMENTS' | translate }}</span>
        </div>
      </a> -->
      <a *ngIf="existInModulesAndCanAccess('TRANSLATIONS')" mat-button routerLink="/translations"
        routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>translate</mat-icon>
          <span>{{ 'MENU.TRANSLATIONS' | translate }}</span>
        </div>
      </a>
      <a *ngIf="existInModulesAndCanAccess('MEDIA')" mat-button routerLink="/media" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>description</mat-icon>
          <span>{{ 'MENU.FILES' | translate }}</span>
        </div>
      </a>
      <mat-divider *ngIf="hasElementsBetweenDivider3And4()" id="4"></mat-divider>
      <a *ngIf="existInModulesAndCanAccess('CONFLICTS')" mat-button routerLink="/conflicts" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>admin_panel_settings</mat-icon>
          <span>{{ 'MENU.CONFLICTS' | translate }}</span>
        </div>
      </a>
      <a *ngIf="existInModulesAndCanAccess('CLAIMS')" mat-button routerLink="/claims" routerLinkActive="active" (click)="closeDrawerOnMenuClick()">
        <div class="alimentium-item-menu">
          <mat-icon>feedback</mat-icon>
          <span>{{ 'MENU.CLAIMS' | translate }}</span>
        </div>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="alim-mad-sidenav-content">
    <button mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async" class="hamburger-button">
      <mat-icon>menu</mat-icon>
    </button>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
